import React from "react";

import { useSelector } from "react-redux";

import { DayView } from "@ds-developer/calendar";

import {
  selectCalendarEventsLoading,
  selectCalendarInitialDate,
  selectCalendarView,
} from "@hubcapp/state";

import { numberDaysForView } from "@hubcapp/components/Calendar/helpers";

import { DayViewProps } from "./types";

const DayViewStateProvider: React.FC<Pick<
  DayViewProps,
  | "events"
  | "onEventClick"
  | "onDateClick"
  | "workingHours"
  | "scrollTime"
  | "workingDays"
>> = ({
  events,
  onEventClick,
  onDateClick,
  workingHours,
  workingDays,
  scrollTime,
}) => {
  const view = useSelector(selectCalendarView);

  const initialDate =
    useSelector(selectCalendarInitialDate) || new Date(Date.now());
  const loading = useSelector(selectCalendarEventsLoading);

  const now = new Date(Date.now());

  return (
    <DayView
      initialDate={initialDate}
      instructorWorkingDays={workingDays}
      now={now}
      onEventClick={onEventClick}
      onDateClick={onDateClick}
      events={events}
      numberDays={numberDaysForView(view)}
      loading={loading}
      workingHours={workingHours}
      scrollTime={scrollTime}
    />
  );
};

export default DayViewStateProvider;
